import { httpClient } from '../api/http.client';
import type { 
  SaleListResponse,
  SaleWithDetails,
  SaleFilters,
  SalesSummary
} from '../../domain/entities/Sale';

export class SaleRepository {
  async getSales(filters: SaleFilters = {}): Promise<SaleListResponse> {
    const params = new URLSearchParams();
    
    if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
    if (filters.offset !== undefined) params.append('offset', filters.offset.toString());
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.sourceId) params.append('sourceId', filters.sourceId.toString());
    if (filters.search) params.append('search', filters.search);

    const queryString = params.toString();

    return await httpClient.get<SaleListResponse>(
      `/api/admin/sales${queryString ? `?${queryString}` : ''}`
    );
  }

  async getSaleById(id: string): Promise<SaleWithDetails> {
    return await httpClient.get<SaleWithDetails>(`/api/admin/sales/${id}`);
  }

  async getSalesSummary(dateFrom?: string, dateTo?: string): Promise<SalesSummary> {
    const params = new URLSearchParams();
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);

    const queryString = params.toString();

    return await httpClient.get<SalesSummary>(
      `/api/admin/sales/summary${queryString ? `?${queryString}` : ''}`
    );
  }
}

export const saleRepository = new SaleRepository();

